import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

import HeroSimple from "../HeroSimple"
import Snippet from "../Snippet"
import Link from "../Link"
import Button from "../Button"
import VideoButton from "../VideoButton"
import { media } from "../../styles"

import heroIlluLeft from "../../images/content/home/hero-left.svg"
import heroIlluRight from "../../images/content/home/hero-right.svg"

const ImageLeft = styled.img`
  left: 10px;
  position: absolute;
  top: 270px;
  width: 101px;

  @media ${media.sm} {
    left: 30px;
    top: 220px;
    width: 120px;
  }

  @media ${media.md} {
    left: 40px;
    top: 250px;
    width: 150px;
  }

  @media ${media.xl} {
    left: 74px;
    top: 326px;
    width: 201px;
  }
`

const ImageRight = styled.img`
  position: absolute;
  right: -10px;
  top: 275px;
  width: 111px;

  @media ${media.sm} {
    right: 20px;
    top: 220px;
    width: 136px;
  }

  @media ${media.md} {
    right: 20px;
    top: 240px;
    width: 160px;
  }

  @media ${media.xl} {
    right: 59px;
    top: 302px;
    width: 204px;
  }
`

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;

  @media ${media.lg} {
    flex-direction: row;
    margin: 30px 0 0;
  }

  @media ${media.xl} {
    margin: 60px 0 0;
  }

  .button {
    justify-content: center;
    min-width: 240px;
  }
`

const HomeHero = () => {
  return (
    <HeroSimple
      header={Snippet({ id: "homeHero", field: "header" })}
      text={Snippet({
        id: "homeHero",
        field: "text",
        md: true,
      })}
      buttonOverride={
        <ButtonRow>
          <VideoButton
            label={Snippet({ id: "homeHeroVideo", field: "linkText" })}
            thumbnail={
              <StaticImage
                alt={Snippet({ id: "homeHeroVideo", field: "linkText" })}
                src="../../images/content/home/video-aboutus-thumbnail.jpg"
              />
            }
            videoUrl={Snippet({ id: "homeHeroVideo", field: "linkUrl" })}
          />
          <Button
            as={Link}
            to={Snippet({ id: "homeHero", field: "linkUrl" })}
            intl={false}
            outline
            arrow
          >
            {Snippet({ id: "homeHero", field: "linkText" })}
          </Button>
        </ButtonRow>
      }
      background={
        <>
          <ImageLeft src={heroIlluLeft} alt="" />
          <ImageRight src={heroIlluRight} alt="" />
        </>
      }
    />
  )
}

export default HomeHero
